import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import AddTaxModal from "../../Modals/addTax";

const TaxList = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("add"); // NEW

  const handleCloseModal = () => {
    setOpen(false);
    setModalType("add"); // reset default if needed
  };

  const rows = [
    {
      id: 1,
      name: "GST",
      value: "5",
    },
    {
      id: 2,
      name: "IGST",
      value: "5",
    },
    {
      id: 3,
      name: "VAT",
      value: "5",
    },
  ];

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => {
              setModalType("add");
              setOpen(true);
            }}
          >
            <AddIcon /> Add Service Fee
          </Button>
        </div>
      </div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tax Name</TableCell>
              <TableCell>Tax Value(%)</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.value}</TableCell>
                <TableCell>
                  <SwitchToggle />
                </TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <IconButton
                        onClick={() => {
                          setModalType("edit");
                          setOpen(true);
                        }}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="edit" />
                      </IconButton>
                    </Box>
                    <Box>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="delete" />
                      </IconButton>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddTaxModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        type={modalType}
      />
    </>
  );
};

export default TaxList;
